import { useAppSelector } from '@/Application/Hooks/Redux';
import useCountdownTimer from '@/modules/perseo-billing/hooks/use-timer-count-down';
import { EPayStatus } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';

import QRInitialContainer from './containers/qr-initial-container';
import QRPendingContainer from './containers/qr-pending-container';
import { CancelQR } from './cencopay-cancel-payment.component';

interface ICencoPayModalBody {
  closeModal: () => void;
}

export const CencoPayModalBody = ({ closeModal }: ICencoPayModalBody) => {
  return (
    <div className="co-flex co-flex-col co-items-center co-pt-4 co-pb-[20px] co-bg-transparent sm:co-bg-[unset]">
      <RenderCencoPayStatus />
      <CancelQR closeModal={closeModal} />
    </div>
  );
};

const RenderCencoPayStatus = () => {
  const isMobile = useMediaQuery('sm');
  const billing = useAppSelector((state) => state?.billing);
  const { cencoPayQR, cencoPayStatus } = billing;

  const countdown = cencoPayQR?.transactionCountdown ?? 0;
  const qrCode = cencoPayQR?.qrCode ?? '';

  useCountdownTimer(countdown);

  const isPending = cencoPayStatus === EPayStatus.PENDING;
  const isInProgress = cencoPayStatus === EPayStatus.IN_PROGRESS;

  if (isMobile && isPending) return <QRPendingContainer />;

  if (isPending) return <QRInitialContainer qrCode={qrCode} />;

  if (isInProgress) return <QRPendingContainer />;

  return <QRInitialContainer qrCode={qrCode} />;
};
